// extracted by mini-css-extract-plugin
export default {"main":"cardstyle3_main__39yV5","w80":"cardstyle3_w80__-jhsl","img":"cardstyle3_img__yjqw3","title":"cardstyle3_title__NAXmi","pin":"cardstyle3_pin__-wfcv"};